/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RequestDeleteBaseRequest } from './RequestDeleteBaseRequest';
import {
    RequestDeleteBaseRequestFromJSON,
    RequestDeleteBaseRequestFromJSONTyped,
    RequestDeleteBaseRequestToJSON,
    RequestDeleteBaseRequestToJSONTyped,
} from './RequestDeleteBaseRequest';

/**
 * 
 * @export
 * @interface RequestDeleteBaseRequestWrapper
 */
export interface RequestDeleteBaseRequestWrapper {
    /**
     * 
     * @type {Array<RequestDeleteBaseRequest>}
     * @memberof RequestDeleteBaseRequestWrapper
     */
    req?: Array<RequestDeleteBaseRequest>;
}

/**
 * Check if a given object implements the RequestDeleteBaseRequestWrapper interface.
 */
export function instanceOfRequestDeleteBaseRequestWrapper(value: object): value is RequestDeleteBaseRequestWrapper {
    return true;
}

export function RequestDeleteBaseRequestWrapperFromJSON(json: any): RequestDeleteBaseRequestWrapper {
    return RequestDeleteBaseRequestWrapperFromJSONTyped(json, false);
}

export function RequestDeleteBaseRequestWrapperFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestDeleteBaseRequestWrapper {
    if (json == null) {
        return json;
    }
    return {
        
        'req': json['req'] == null ? undefined : ((json['req'] as Array<any>).map(RequestDeleteBaseRequestFromJSON)),
    };
}

export function RequestDeleteBaseRequestWrapperToJSON(json: any): RequestDeleteBaseRequestWrapper {
    return RequestDeleteBaseRequestWrapperToJSONTyped(json, false);
}

export function RequestDeleteBaseRequestWrapperToJSONTyped(value?: RequestDeleteBaseRequestWrapper | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'req': value['req'] == null ? undefined : ((value['req'] as Array<any>).map(RequestDeleteBaseRequestToJSON)),
    };
}

